import { c as _c } from "react/compiler-runtime";
import { addDays, endOfMonth, format, getDay, isAfter, isBefore, startOfDay, startOfMonth } from 'date-fns';
import { useMemo } from 'react';
import type { CalendarEvent } from '@/app/(marketing-site)/bezplatna-konsultacja/_components/CalendarEvent';
import { WEEK_DAYS } from '../_components/HourSelector';
interface UseAvailableDaysProps {
  selectedEventsMap: Map<string, CalendarEvent[]>;
  selectedHoursByDay: Record<WEEK_DAYS, string[]>;
  excludedRecurringEvents: Set<string>;
}
export function useAvailableDays(t0) {
  const $ = _c(6);
  const {
    selectedEventsMap,
    selectedHoursByDay,
    excludedRecurringEvents
  } = t0;
  let currentMonthStart;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    const today = new Date();
    currentMonthStart = startOfMonth(today);
    t1 = endOfMonth(today);
    $[0] = currentMonthStart;
    $[1] = t1;
  } else {
    currentMonthStart = $[0];
    t1 = $[1];
  }
  const currentMonthEnd = t1;
  let result;
  if ($[2] !== excludedRecurringEvents || $[3] !== selectedEventsMap || $[4] !== selectedHoursByDay) {
    const today_0 = startOfDay(new Date());
    result = new Set();
    for (const [date, events] of selectedEventsMap.entries()) {
      const hasActiveEvent = events.some(event => {
        if (event.isRecurring) {
          const hour = format(event.startTime, "HH:mm");
          const exclusionKey = `${date}-${hour}`;
          if (excludedRecurringEvents.has(exclusionKey)) {
            return false;
          }
          const dayOfWeek = getDay(event.startTime);
          const dayName = Object.values(WEEK_DAYS)[dayOfWeek === 0 ? 6 : dayOfWeek - 1];
          const isInSelectedHours = selectedHoursByDay[dayName]?.includes(hour);
          return isInSelectedHours ?? false;
        }
        return true;
      });
      if (hasActiveEvent) {
        result.add(date);
      }
    }
    let currentDate = currentMonthStart;
    while (!isAfter(currentDate, currentMonthEnd)) {
      const dayOfWeek_0 = getDay(currentDate);
      const dayName_0 = Object.values(WEEK_DAYS)[dayOfWeek_0 === 0 ? 6 : dayOfWeek_0 - 1];
      const hours = selectedHoursByDay[dayName_0];
      if (hours?.length) {
        const formatted = format(currentDate, "yyyy.MM.dd");
        const hasActiveHour = hours.some(hour_0 => {
          if (excludedRecurringEvents.has(`${formatted}-${hour_0}`)) {
            return false;
          }
          if (format(currentDate, "yyyy.MM.dd") === format(today_0, "yyyy.MM.dd")) {
            const [h, m] = hour_0.split(":").map(Number);
            const eventTime = new Date(currentDate);
            eventTime.setHours(h, m, 0, 0);
            if (eventTime < new Date()) {
              return false;
            }
          }
          return true;
        });
        if (hasActiveHour && !isBefore(startOfDay(currentDate), today_0)) {
          result.add(formatted);
        }
      }
      currentDate = addDays(currentDate, 1);
    }
    $[2] = excludedRecurringEvents;
    $[3] = selectedEventsMap;
    $[4] = selectedHoursByDay;
    $[5] = result;
  } else {
    result = $[5];
  }
  return result;
}